<div style="margin-top: 3%">
    <div class="section-heading">
        <h2 class="h2_font_size">Spin n Win</h2>
        <div class="hr" style="padding: 4px;"></div>
    </div>
</div>

<!-- Navigation bar with three buttons -->
<div class="nav-bar">
    <button class="nav-btn" [ngClass]="{ 'nav-btn-active': activeTab === 'home' }" (click)="filterCoupons('home')">
        AVAILABLE
        <div class="coupon-message">{{homeCount}} Products</div>
    </button>
    <button class="nav-btn" [ngClass]="{ 'nav-btn-active': activeTab === 'redeemed' }"
        (click)="filterCoupons('redeemed')">
        REDEEMED
        <div class="coupon-message">{{redeemedCount}} Products</div>
    </button>
</div>

<div class="container" style="margin-top: 20px">
    <div class="row">
        <div class="col-md-12">
            <div class="container">
                <div class="row">
                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-6" style="padding: 0;"
                        *ngFor="let product of discountProducts">
                        <div class="product_detaiils">
                            <!--Card-->
                            <div class="card card-cascade wider">
                                <!--Card image-->
                                <a>
                                    <div class="view overlay hm-white-slight">
                                        <img src="../../../../assets/img/{{ product.productDetails.productImage }}"
                                            class="img-fluid" alt="Image not found" width="360px" height="300px"
                                            onerror="this.src='../../../../assets/img/defaultCake.webp';"
                                            [routerLink]="['/product', product.productCode]" />
                                        <img *ngIf="product.productDetails.foodType == 'Veg'"
                                            class="img-responsive img_align" src="../../../../assets/img/Veg.webp"
                                            alt="" />
                                        <img *ngIf="product.productDetails.foodType == 'Non-Veg'"
                                            class="img-responsive img_align" src="../../../../assets/img/Nonveg.webp"
                                            alt="" />
                                    </div>
                                </a>

                                <div class="card-body text-center">
                                    <p class="card-title product_name">
                                        <strong style="height: 80%;">
                                            <a [routerLink]="['/product', product.productCode]"
                                                routerLinkActive="router-link-active">
                                                {{product.productDetails.productName }}</a>
                                        </strong>
                                        <strong class="price_style">
                                            <span>₹ {{ product.productDetails.price | number: "1.2-2"
                                                }}</span>
                                        </strong>
                                    </p>

                                    <p>
                                        <!-- <span>{{product?.productDetails?.portion_Weight }}</span> -->
                                    </p>

                                    <div class="card-footer">
                                        <button type="button" class="add_to_cart_btn luck-btn-animate"
                                            (click)="tryMyLuck(product)" *ngIf="product.status == null">
                                            <span class="spin-icon"><img src="assets/img/spintowin.png"
                                                    alt="Shuffling..." width="100" /></span> Spin to Win
                                        </button>

                                        <button type="button" class="add_to_cart_btn luck-btn-animate claim-btn"
                                            (click)="tryMyLuck(product)" *ngIf="product.status == 'Generated'">
                                            <i class="fas fa-gift"></i>
                                            Claim Reward
                                        </button>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Luck Result Modal -->
                    <div class="luck-modal" *ngIf="showLuckModal">
                        <div class="luck-content">
                            <canvas #confettiCanvas class="confetti-canvas"></canvas>

                            <button class="close-btn" (click)="closeModal()">×</button>

                            <!-- SHUFFLE ANIMATION BLOCK -->
                            <ng-container *ngIf="isShuffling; else rewardContent">
                                <div class="shuffling-block">
                                    <h2 class="loading-text">🎁 Loading your deal...</h2>
                                    <div class="shuffle-animation">
                                        <img src="assets/img/spintowin.png" alt="Shuffling..." width="100" />
                                    </div>
                                </div>
                            </ng-container>

                            <!-- ORIGINAL CONTENT BLOCK -->
                            <ng-template #rewardContent>
                                <h2 class="win-text animate-bounce-in">🎉 Congratulations! 🎉</h2>
                                <h3 class="discount-text">Claim Your Deal</h3>

                                <div class="reward-options">
                                    <!-- Product Reward -->
                                    <button class="reward-btn" (click)="onRewardTypeChange('product')"
                                        [class.active]="selectedRewardType === 'product'">
                                        <div class="reward-column">
                                            <div class="product-preview">
                                                <img [src]="'../../../../assets/img/' + selectedRewardProduct?.productDetails?.productImage"
                                                    alt="product" />
                                            </div>
                                            <span class="reward-title">{{
                                                selectedRewardProduct?.productDetails.productName }}</span>
                                            <span class="reward-subtext">₹{{ selectedRewardProduct?.productDetails.price
                                                |
                                                number: "1.2-2" }}</span>
                                        </div>
                                    </button>

                                    <span class="or_text">OR</span>

                                    <!-- Money Reward -->
                                    <button class="reward-btn" (click)="onRewardTypeChange('money')"
                                        [class.active]="selectedRewardType === 'money'">
                                        <div class="reward-column">
                                            <div class="product-preview">
                                                <img src="../../../../assets/img/cashflow.gif" alt="Cash Reward"
                                                    class="cash-image" />
                                            </div>
                                            <span class="reward-title">Cash Discount</span>
                                            <span class="reward-subtext">₹{{ wonDiscount }}</span>
                                        </div>
                                    </button>
                                </div>

                                <p class="choose-message" *ngIf="!selectedRewardType">Please choose one reward to
                                    proceed</p>

                                <!-- <div class="product-preview" *ngIf="selectedRewardType === 'product'">
                                    <img [src]="'../../../../assets/img/' + selectedRewardProduct?.productDetails?.productImage"
                                        alt="product" />
                                    <p class="card-title product-name-modal">
                                        <strong><span>{{selectedRewardProduct?.productDetails?.productName
                                                }}</span></strong>
                                        <strong class="price_style"><span>₹ {{
                                                selectedRewardProduct?.productDetails?.price |
                                                number: "1.2-2" }}</span></strong>
                                    </p>
                                </div> -->

                                <!-- Cash Preview (if money is selected) -->
                                <!-- <div class="product-preview" *ngIf="selectedRewardType === 'money'">
                                    <img src="../../../../assets/img/cashflow.gif" alt="Cash Reward"
                                        class="cash-image" />
                                    <p class="card-title product-name-modal">
                                        <strong><span>Cash Discount Reward</span></strong>
                                        <strong class="price_style"><span>₹{{ wonDiscount }}</span></strong>
                                    </p>
                                </div> -->


                                <div class="qr-wrapper" *ngIf="selectedRewardType">
                                    <qrcode [qrdata]="qrData" [width]="150" [backgroundColor]="'transparent'">
                                    </qrcode>
                                </div>

                                <p class="scan-note" *ngIf="selectedRewardType">Show this QR code at our store to claim
                                    your deal.</p>
                            </ng-template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="col-md-12">
    <h4 *ngIf="discountProducts.length === 0" class="empty">
        <i class="i-style">
            No Discounts
            Are
            Currently Available
        </i>
    </h4>
</div>